import { Dispatch } from 'react';
import { Id } from 'react-toastify';
import { dismissToast, updateToast } from '../Toaster';
import Prompts from '../../context/prompts/index.d';

const ENTITLEMENT_LAPSE_BY_ERROR_CODE: Record<
  string,
  Prompts.OpenEntitlementLapsePrompt['payload']['lapseType']
> = {
  take_voice_access_denied: 'voice',
  take_sample_rate_access_denied: 'sampleRate',
};

export const getGraphQLErrorCode = (error: unknown): string | undefined => {
  const graphQLErrors = (error as { graphQLErrors?: Array<unknown> })
    ?.graphQLErrors;
  const firstError = graphQLErrors?.[0] as
    | { extensions?: { code?: string } }
    | undefined;
  return firstError?.extensions?.code;
};

const handleEntitlementDownloadError = ({
  errorCode,
  toastId,
  errorMessage,
  dispatchPrompt,
  onTimeout,
}: {
  errorCode: string | null | undefined;
  toastId: Id | undefined;
  errorMessage: string;
  dispatchPrompt: Dispatch<Prompts.ContextActions>;
  onTimeout?: () => void;
}): void => {
  const lapseType = errorCode
    ? ENTITLEMENT_LAPSE_BY_ERROR_CODE[errorCode]
    : undefined;

  if (lapseType) {
    dismissToast(toastId ?? '');
    dispatchPrompt({
      type: 'OpenEntitlementLapsePrompt',
      payload: { lapseType },
    });
    return;
  }

  if (onTimeout) {
    dismissToast(toastId ?? '');
    onTimeout();
    return;
  }

  updateToast(toastId ?? '', {
    message: errorMessage,
    type: 'error',
  });
};

export default handleEntitlementDownloadError;
